/**
 * Do not edit directly
 * Generated on Mon, 01 Apr 2024 22:36:33 GMT
 */
const varnishTokens = {
    "breakpoint": {
        "xs": {
            "value": "0",
            "$type": "dimension",
            "name": "breakpoint-xs",
            "attributes": {
                "category": "breakpoint",
                "type": "xs"
            },
            "path": [
                "breakpoint",
                "xs"
            ]
        },
        "sm": {
            "value": "37.5rem",
            "$type": "dimension",
            "name": "breakpoint-sm",
            "attributes": {
                "category": "breakpoint",
                "type": "sm"
            },
            "path": [
                "breakpoint",
                "sm"
            ]
        },
        "md": {
            "value": "56.25rem",
            "$type": "dimension",
            "name": "breakpoint-md",
            "attributes": {
                "category": "breakpoint",
                "type": "md"
            },
            "path": [
                "breakpoint",
                "md"
            ]
        },
        "lg": {
            "value": "75rem",
            "$type": "dimension",
            "name": "breakpoint-lg",
            "attributes": {
                "category": "breakpoint",
                "type": "lg"
            },
            "path": [
                "breakpoint",
                "lg"
            ]
        },
        "xl": {
            "value": "96rem",
            "$type": "dimension",
            "name": "breakpoint-xl",
            "attributes": {
                "category": "breakpoint",
                "type": "xl"
            },
            "path": [
                "breakpoint",
                "xl"
            ]
        }
    },
    "color": {
        "R1": {
            "value": "rgba(255, 242, 242, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "R1",
                "hex": "fff2f2",
                "rgb": {
                    "r": 255,
                    "g": 242,
                    "b": 242,
                    "a": 1
                },
                "hsl": {
                    "h": 0,
                    "s": 1,
                    "l": 0.9745098039215686,
                    "a": 1
                },
                "hsv": {
                    "h": 0,
                    "s": 0.050980392156862786,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-r1",
            "path": [
                "color",
                "R1"
            ]
        },
        "R2": {
            "value": "rgba(255, 225, 224, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "R2",
                "hex": "ffe1e0",
                "rgb": {
                    "r": 255,
                    "g": 225,
                    "b": 224,
                    "a": 1
                },
                "hsl": {
                    "h": 1.9354838709677349,
                    "s": 1,
                    "l": 0.9392156862745098,
                    "a": 1
                },
                "hsv": {
                    "h": 1.9354838709677349,
                    "s": 0.1215686274509804,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-r2",
            "path": [
                "color",
                "R2"
            ]
        },
        "R3": {
            "value": "rgba(253, 193, 192, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "R3",
                "hex": "fdc1c0",
                "rgb": {
                    "r": 253,
                    "g": 193,
                    "b": 192,
                    "a": 1
                },
                "hsl": {
                    "h": 0.9836065573770454,
                    "s": 0.9384615384615387,
                    "l": 0.8725490196078431,
                    "a": 1
                },
                "hsv": {
                    "h": 0.9836065573770454,
                    "s": 0.24110671936758896,
                    "v": 0.9921568627450981,
                    "a": 1
                }
            },
            "name": "color-r3",
            "path": [
                "color",
                "R3"
            ]
        },
        "R4": {
            "value": "rgba(255, 159, 158, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "R4",
                "hex": "ff9f9e",
                "rgb": {
                    "r": 255,
                    "g": 159,
                    "b": 158,
                    "a": 1
                },
                "hsl": {
                    "h": 0.6185567010309256,
                    "s": 1,
                    "l": 0.8098039215686275,
                    "a": 1
                },
                "hsv": {
                    "h": 0.6185567010309256,
                    "s": 0.3803921568627451,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-r4",
            "path": [
                "color",
                "R4"
            ]
        },
        "R5": {
            "value": "rgba(249, 128, 127, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "R5",
                "hex": "f9807f",
                "rgb": {
                    "r": 249,
                    "g": 128,
                    "b": 127,
                    "a": 1
                },
                "hsl": {
                    "h": 0.49180327868852286,
                    "s": 0.9104477611940299,
                    "l": 0.7372549019607844,
                    "a": 1
                },
                "hsv": {
                    "h": 0.49180327868852286,
                    "s": 0.4899598393574297,
                    "v": 0.9764705882352941,
                    "a": 1
                }
            },
            "name": "color-r5",
            "path": [
                "color",
                "R5"
            ]
        },
        "R6": {
            "value": "rgba(247, 96, 95, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "R6",
                "hex": "f7605f",
                "rgb": {
                    "r": 247,
                    "g": 96,
                    "b": 95,
                    "a": 1
                },
                "hsl": {
                    "h": 0.39473684210526183,
                    "s": 0.9047619047619049,
                    "l": 0.6705882352941177,
                    "a": 1
                },
                "hsv": {
                    "h": 0.39473684210526183,
                    "s": 0.6153846153846154,
                    "v": 0.9686274509803922,
                    "a": 1
                }
            },
            "name": "color-r6",
            "path": [
                "color",
                "R6"
            ]
        },
        "R7": {
            "value": "rgba(231, 80, 79, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "R7",
                "hex": "e7504f",
                "rgb": {
                    "r": 231,
                    "g": 80,
                    "b": 79,
                    "a": 1
                },
                "hsl": {
                    "h": 0.39473684210526183,
                    "s": 0.7599999999999999,
                    "l": 0.607843137254902,
                    "a": 1
                },
                "hsv": {
                    "h": 0.39473684210526183,
                    "s": 0.658008658008658,
                    "v": 0.9058823529411765,
                    "a": 1
                }
            },
            "name": "color-r7",
            "path": [
                "color",
                "R7"
            ]
        },
        "R8": {
            "value": "rgba(214, 63, 63, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "R8",
                "hex": "d63f3f",
                "rgb": {
                    "r": 214,
                    "g": 63,
                    "b": 63,
                    "a": 1
                },
                "hsl": {
                    "h": 0,
                    "s": 0.6480686695278971,
                    "l": 0.5431372549019609,
                    "a": 1
                },
                "hsv": {
                    "h": 0,
                    "s": 0.705607476635514,
                    "v": 0.8392156862745098,
                    "a": 1
                }
            },
            "name": "color-r8",
            "path": [
                "color",
                "R8"
            ]
        },
        "R9": {
            "value": "rgba(191, 45, 45, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "R9",
                "hex": "bf2d2d",
                "rgb": {
                    "r": 191,
                    "g": 45,
                    "b": 45,
                    "a": 1
                },
                "hsl": {
                    "h": 0,
                    "s": 0.6186440677966101,
                    "l": 0.4627450980392157,
                    "a": 1
                },
                "hsv": {
                    "h": 0,
                    "s": 0.7643979057591622,
                    "v": 0.7490196078431373,
                    "a": 1
                }
            },
            "name": "color-r9",
            "path": [
                "color",
                "R9"
            ]
        },
        "R10": {
            "value": "rgba(147, 34, 34, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "R10",
                "hex": "932222",
                "rgb": {
                    "r": 147,
                    "g": 34,
                    "b": 34,
                    "a": 1
                },
                "hsl": {
                    "h": 0,
                    "s": 0.6243093922651934,
                    "l": 0.3549019607843137,
                    "a": 1
                },
                "hsv": {
                    "h": 0,
                    "s": 0.7687074829931974,
                    "v": 0.5764705882352941,
                    "a": 1
                }
            },
            "name": "color-r10",
            "path": [
                "color",
                "R10"
            ]
        },
        "O1": {
            "value": "rgba(255, 249, 232, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "O1",
                "hex": "fff9e8",
                "rgb": {
                    "r": 255,
                    "g": 249,
                    "b": 232,
                    "a": 1
                },
                "hsl": {
                    "h": 44.3478260869565,
                    "s": 1,
                    "l": 0.9549019607843137,
                    "a": 1
                },
                "hsv": {
                    "h": 44.3478260869565,
                    "s": 0.09019607843137256,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o1",
            "path": [
                "color",
                "O1"
            ]
        },
        "O2": {
            "value": "rgba(255, 241, 196, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "O2",
                "hex": "fff1c4",
                "rgb": {
                    "r": 255,
                    "g": 241,
                    "b": 196,
                    "a": 1
                },
                "hsl": {
                    "h": 45.76271186440677,
                    "s": 1,
                    "l": 0.884313725490196,
                    "a": 1
                },
                "hsv": {
                    "h": 45.76271186440677,
                    "s": 0.2313725490196078,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o2",
            "path": [
                "color",
                "O2"
            ]
        },
        "O3": {
            "value": "rgba(255, 227, 148, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "O3",
                "hex": "ffe394",
                "rgb": {
                    "r": 255,
                    "g": 227,
                    "b": 148,
                    "a": 1
                },
                "hsl": {
                    "h": 44.29906542056074,
                    "s": 1,
                    "l": 0.7901960784313726,
                    "a": 1
                },
                "hsv": {
                    "h": 44.29906542056074,
                    "s": 0.41960784313725485,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o3",
            "path": [
                "color",
                "O3"
            ]
        },
        "O4": {
            "value": "rgba(255, 212, 93, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "O4",
                "hex": "ffd45d",
                "rgb": {
                    "r": 255,
                    "g": 212,
                    "b": 93,
                    "a": 1
                },
                "hsl": {
                    "h": 44.07407407407408,
                    "s": 1,
                    "l": 0.6823529411764706,
                    "a": 1
                },
                "hsv": {
                    "h": 44.07407407407408,
                    "s": 0.6352941176470588,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o4",
            "path": [
                "color",
                "O4"
            ]
        },
        "O5": {
            "value": "rgba(255, 199, 46, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "O5",
                "hex": "ffc72e",
                "rgb": {
                    "r": 255,
                    "g": 199,
                    "b": 46,
                    "a": 1
                },
                "hsl": {
                    "h": 43.92344497607656,
                    "s": 1,
                    "l": 0.5901960784313726,
                    "a": 1
                },
                "hsv": {
                    "h": 43.92344497607656,
                    "s": 0.8196078431372549,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o5",
            "path": [
                "color",
                "O5"
            ]
        },
        "O6": {
            "value": "rgba(255, 187, 0, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "O6",
                "hex": "ffbb00",
                "rgb": {
                    "r": 255,
                    "g": 187,
                    "b": 0,
                    "a": 1
                },
                "hsl": {
                    "h": 44,
                    "s": 1,
                    "l": 0.5,
                    "a": 1
                },
                "hsv": {
                    "h": 44,
                    "s": 1,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o6",
            "path": [
                "color",
                "O6"
            ]
        },
        "O7": {
            "value": "rgba(255, 162, 0, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "O7",
                "hex": "ffa200",
                "rgb": {
                    "r": 255,
                    "g": 162,
                    "b": 0,
                    "a": 1
                },
                "hsl": {
                    "h": 38.11764705882353,
                    "s": 1,
                    "l": 0.5,
                    "a": 1
                },
                "hsv": {
                    "h": 38.11764705882353,
                    "s": 1,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o7",
            "path": [
                "color",
                "O7"
            ]
        },
        "O8": {
            "value": "rgba(255, 145, 0, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "O8",
                "hex": "ff9100",
                "rgb": {
                    "r": 255,
                    "g": 145,
                    "b": 0,
                    "a": 1
                },
                "hsl": {
                    "h": 34.11764705882353,
                    "s": 1,
                    "l": 0.5,
                    "a": 1
                },
                "hsv": {
                    "h": 34.11764705882353,
                    "s": 1,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-o8",
            "path": [
                "color",
                "O8"
            ]
        },
        "O9": {
            "value": "rgba(221, 101, 2, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "O9",
                "hex": "dd6502",
                "rgb": {
                    "r": 221,
                    "g": 101,
                    "b": 2,
                    "a": 1
                },
                "hsl": {
                    "h": 27.12328767123287,
                    "s": 0.9820627802690584,
                    "l": 0.4372549019607843,
                    "a": 1
                },
                "hsv": {
                    "h": 27.12328767123287,
                    "s": 0.9909502262443439,
                    "v": 0.8666666666666667,
                    "a": 1
                }
            },
            "name": "color-o9",
            "path": [
                "color",
                "O9"
            ]
        },
        "O10": {
            "value": "rgba(169, 64, 6, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "O10",
                "hex": "a94006",
                "rgb": {
                    "r": 169,
                    "g": 64,
                    "b": 6,
                    "a": 1
                },
                "hsl": {
                    "h": 21.349693251533743,
                    "s": 0.9314285714285714,
                    "l": 0.3431372549019608,
                    "a": 1
                },
                "hsv": {
                    "h": 21.349693251533743,
                    "s": 0.9644970414201183,
                    "v": 0.6627450980392157,
                    "a": 1
                }
            },
            "name": "color-o10",
            "path": [
                "color",
                "O10"
            ]
        },
        "G1": {
            "value": "rgba(228, 255, 247, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "G1",
                "hex": "e4fff7",
                "rgb": {
                    "r": 228,
                    "g": 255,
                    "b": 247,
                    "a": 1
                },
                "hsl": {
                    "h": 162.22222222222223,
                    "s": 1,
                    "l": 0.9470588235294117,
                    "a": 1
                },
                "hsv": {
                    "h": 162.22222222222223,
                    "s": 0.10588235294117643,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-g1",
            "path": [
                "color",
                "G1"
            ]
        },
        "G2": {
            "value": "rgba(193, 247, 230, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "G2",
                "hex": "c1f7e6",
                "rgb": {
                    "r": 193,
                    "g": 247,
                    "b": 230,
                    "a": 1
                },
                "hsl": {
                    "h": 161.11111111111111,
                    "s": 0.7714285714285718,
                    "l": 0.8627450980392157,
                    "a": 1
                },
                "hsv": {
                    "h": 161.11111111111111,
                    "s": 0.21862348178137656,
                    "v": 0.9686274509803922,
                    "a": 1
                }
            },
            "name": "color-g2",
            "path": [
                "color",
                "G2"
            ]
        },
        "G3": {
            "value": "rgba(152, 234, 208, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "G3",
                "hex": "98ead0",
                "rgb": {
                    "r": 152,
                    "g": 234,
                    "b": 208,
                    "a": 1
                },
                "hsl": {
                    "h": 160.97560975609758,
                    "s": 0.6612903225806449,
                    "l": 0.7568627450980392,
                    "a": 1
                },
                "hsv": {
                    "h": 160.97560975609758,
                    "s": 0.3504273504273504,
                    "v": 0.9176470588235294,
                    "a": 1
                }
            },
            "name": "color-g3",
            "path": [
                "color",
                "G3"
            ]
        },
        "G4": {
            "value": "rgba(112, 221, 186, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "G4",
                "hex": "70ddba",
                "rgb": {
                    "r": 112,
                    "g": 221,
                    "b": 186,
                    "a": 1
                },
                "hsl": {
                    "h": 160.73394495412845,
                    "s": 0.6158192090395481,
                    "l": 0.6529411764705882,
                    "a": 1
                },
                "hsv": {
                    "h": 160.73394495412845,
                    "s": 0.49321266968325794,
                    "v": 0.8666666666666667,
                    "a": 1
                }
            },
            "name": "color-g4",
            "path": [
                "color",
                "G4"
            ]
        },
        "G5": {
            "value": "rgba(71, 207, 164, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "G5",
                "hex": "47cfa4",
                "rgb": {
                    "r": 71,
                    "g": 207,
                    "b": 164,
                    "a": 1
                },
                "hsl": {
                    "h": 161.02941176470588,
                    "s": 0.5862068965517241,
                    "l": 0.5450980392156863,
                    "a": 1
                },
                "hsv": {
                    "h": 161.02941176470588,
                    "s": 0.6570048309178744,
                    "v": 0.8117647058823529,
                    "a": 1
                }
            },
            "name": "color-g5",
            "path": [
                "color",
                "G5"
            ]
        },
        "G6": {
            "value": "rgba(30, 194, 142, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "G6",
                "hex": "1ec28e",
                "rgb": {
                    "r": 30,
                    "g": 194,
                    "b": 142,
                    "a": 1
                },
                "hsl": {
                    "h": 160.97560975609758,
                    "s": 0.7321428571428571,
                    "l": 0.4392156862745098,
                    "a": 1
                },
                "hsv": {
                    "h": 160.97560975609758,
                    "s": 0.845360824742268,
                    "v": 0.7607843137254902,
                    "a": 1
                }
            },
            "name": "color-g6",
            "path": [
                "color",
                "G6"
            ]
        },
        "G7": {
            "value": "rgba(20, 168, 125, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "G7",
                "hex": "14a87d",
                "rgb": {
                    "r": 20,
                    "g": 168,
                    "b": 125,
                    "a": 1
                },
                "hsl": {
                    "h": 162.56756756756758,
                    "s": 0.7872340425531914,
                    "l": 0.3686274509803922,
                    "a": 1
                },
                "hsv": {
                    "h": 162.56756756756758,
                    "s": 0.8809523809523808,
                    "v": 0.6588235294117647,
                    "a": 1
                }
            },
            "name": "color-g7",
            "path": [
                "color",
                "G7"
            ]
        },
        "G8": {
            "value": "rgba(10, 143, 107, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "G8",
                "hex": "0a8f6b",
                "rgb": {
                    "r": 10,
                    "g": 143,
                    "b": 107,
                    "a": 1
                },
                "hsl": {
                    "h": 163.75939849624058,
                    "s": 0.8692810457516341,
                    "l": 0.3,
                    "a": 1
                },
                "hsv": {
                    "h": 163.75939849624058,
                    "s": 0.9300699300699301,
                    "v": 0.5607843137254902,
                    "a": 1
                }
            },
            "name": "color-g8",
            "path": [
                "color",
                "G8"
            ]
        },
        "G9": {
            "value": "rgba(0, 117, 90, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "G9",
                "hex": "00755a",
                "rgb": {
                    "r": 0,
                    "g": 117,
                    "b": 90,
                    "a": 1
                },
                "hsl": {
                    "h": 166.15384615384613,
                    "s": 1,
                    "l": 0.22941176470588234,
                    "a": 1
                },
                "hsv": {
                    "h": 166.15384615384613,
                    "s": 1,
                    "v": 0.4588235294117647,
                    "a": 1
                }
            },
            "name": "color-g9",
            "path": [
                "color",
                "G9"
            ]
        },
        "G10": {
            "value": "rgba(0, 83, 64, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "G10",
                "hex": "005340",
                "rgb": {
                    "r": 0,
                    "g": 83,
                    "b": 64,
                    "a": 1
                },
                "hsl": {
                    "h": 166.26506024096383,
                    "s": 1,
                    "l": 0.1627450980392157,
                    "a": 1
                },
                "hsv": {
                    "h": 166.26506024096383,
                    "s": 1,
                    "v": 0.3254901960784314,
                    "a": 1
                }
            },
            "name": "color-g10",
            "path": [
                "color",
                "G10"
            ]
        },
        "T1": {
            "value": "rgba(230, 253, 254, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "T1",
                "hex": "e6fdfe",
                "rgb": {
                    "r": 230,
                    "g": 253,
                    "b": 254,
                    "a": 1
                },
                "hsl": {
                    "h": 182.5,
                    "s": 0.9230769230769234,
                    "l": 0.9490196078431372,
                    "a": 1
                },
                "hsv": {
                    "h": 182.5,
                    "s": 0.09448818897637795,
                    "v": 0.996078431372549,
                    "a": 1
                }
            },
            "name": "color-t1",
            "path": [
                "color",
                "T1"
            ]
        },
        "T2": {
            "value": "rgba(198, 243, 246, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "T2",
                "hex": "c6f3f6",
                "rgb": {
                    "r": 198,
                    "g": 243,
                    "b": 246,
                    "a": 1
                },
                "hsl": {
                    "h": 183.75000000000003,
                    "s": 0.7272727272727276,
                    "l": 0.8705882352941177,
                    "a": 1
                },
                "hsv": {
                    "h": 183.75000000000003,
                    "s": 0.1951219512195122,
                    "v": 0.9647058823529412,
                    "a": 1
                }
            },
            "name": "color-t2",
            "path": [
                "color",
                "T2"
            ]
        },
        "T3": {
            "value": "rgba(154, 231, 236, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "T3",
                "hex": "9ae7ec",
                "rgb": {
                    "r": 154,
                    "g": 231,
                    "b": 236,
                    "a": 1
                },
                "hsl": {
                    "h": 183.65853658536585,
                    "s": 0.6833333333333335,
                    "l": 0.7647058823529411,
                    "a": 1
                },
                "hsv": {
                    "h": 183.65853658536585,
                    "s": 0.34745762711864414,
                    "v": 0.9254901960784314,
                    "a": 1
                }
            },
            "name": "color-t3",
            "path": [
                "color",
                "T3"
            ]
        },
        "T4": {
            "value": "rgba(110, 220, 227, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "T4",
                "hex": "6edce3",
                "rgb": {
                    "r": 110,
                    "g": 220,
                    "b": 227,
                    "a": 1
                },
                "hsl": {
                    "h": 183.5897435897436,
                    "s": 0.6763005780346819,
                    "l": 0.6607843137254902,
                    "a": 1
                },
                "hsv": {
                    "h": 183.5897435897436,
                    "s": 0.5154185022026431,
                    "v": 0.8901960784313725,
                    "a": 1
                }
            },
            "name": "color-t4",
            "path": [
                "color",
                "T4"
            ]
        },
        "T5": {
            "value": "rgba(66, 208, 217, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "T5",
                "hex": "42d0d9",
                "rgb": {
                    "r": 66,
                    "g": 208,
                    "b": 217,
                    "a": 1
                },
                "hsl": {
                    "h": 183.57615894039733,
                    "s": 0.6651982378854625,
                    "l": 0.5549019607843138,
                    "a": 1
                },
                "hsv": {
                    "h": 183.57615894039733,
                    "s": 0.6958525345622119,
                    "v": 0.8509803921568627,
                    "a": 1
                }
            },
            "name": "color-t5",
            "path": [
                "color",
                "T5"
            ]
        },
        "T6": {
            "value": "rgba(22, 196, 207, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "T6",
                "hex": "16c4cf",
                "rgb": {
                    "r": 22,
                    "g": 196,
                    "b": 207,
                    "a": 1
                },
                "hsl": {
                    "h": 183.56756756756758,
                    "s": 0.8078602620087336,
                    "l": 0.44901960784313727,
                    "a": 1
                },
                "hsv": {
                    "h": 183.56756756756758,
                    "s": 0.893719806763285,
                    "v": 0.8117647058823529,
                    "a": 1
                }
            },
            "name": "color-t6",
            "path": [
                "color",
                "T6"
            ]
        },
        "T7": {
            "value": "rgba(15, 169, 182, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "T7",
                "hex": "0fa9b6",
                "rgb": {
                    "r": 15,
                    "g": 169,
                    "b": 182,
                    "a": 1
                },
                "hsl": {
                    "h": 184.67065868263472,
                    "s": 0.8477157360406091,
                    "l": 0.3862745098039216,
                    "a": 1
                },
                "hsv": {
                    "h": 184.67065868263472,
                    "s": 0.9175824175824175,
                    "v": 0.7137254901960784,
                    "a": 1
                }
            },
            "name": "color-t7",
            "path": [
                "color",
                "T7"
            ]
        },
        "T8": {
            "value": "rgba(7, 142, 158, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "T8",
                "hex": "078e9e",
                "rgb": {
                    "r": 7,
                    "g": 142,
                    "b": 158,
                    "a": 1
                },
                "hsl": {
                    "h": 186.35761589403972,
                    "s": 0.9151515151515152,
                    "l": 0.3235294117647059,
                    "a": 1
                },
                "hsv": {
                    "h": 186.35761589403972,
                    "s": 0.9556962025316456,
                    "v": 0.6196078431372549,
                    "a": 1
                }
            },
            "name": "color-t8",
            "path": [
                "color",
                "T8"
            ]
        },
        "T9": {
            "value": "rgba(0, 115, 133, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "T9",
                "hex": "007385",
                "rgb": {
                    "r": 0,
                    "g": 115,
                    "b": 133,
                    "a": 1
                },
                "hsl": {
                    "h": 188.1203007518797,
                    "s": 1,
                    "l": 0.2607843137254902,
                    "a": 1
                },
                "hsv": {
                    "h": 188.1203007518797,
                    "s": 1,
                    "v": 0.5215686274509804,
                    "a": 1
                }
            },
            "name": "color-t9",
            "path": [
                "color",
                "T9"
            ]
        },
        "T10": {
            "value": "rgba(0, 71, 82, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "T10",
                "hex": "004752",
                "rgb": {
                    "r": 0,
                    "g": 71,
                    "b": 82,
                    "a": 1
                },
                "hsl": {
                    "h": 188.04878048780486,
                    "s": 1,
                    "l": 0.1607843137254902,
                    "a": 1
                },
                "hsv": {
                    "h": 188.04878048780486,
                    "s": 1,
                    "v": 0.3215686274509804,
                    "a": 1
                }
            },
            "name": "color-t10",
            "path": [
                "color",
                "T10"
            ]
        },
        "A1": {
            "value": "rgba(242, 252, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "A1",
                "hex": "f2fcff",
                "rgb": {
                    "r": 242,
                    "g": 252,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 193.8461538461538,
                    "s": 1,
                    "l": 0.9745098039215686,
                    "a": 1
                },
                "hsv": {
                    "h": 193.8461538461538,
                    "s": 0.050980392156862786,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-a1",
            "path": [
                "color",
                "A1"
            ]
        },
        "A2": {
            "value": "rgba(224, 249, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "A2",
                "hex": "e0f9ff",
                "rgb": {
                    "r": 224,
                    "g": 249,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 191.6129032258065,
                    "s": 1,
                    "l": 0.9392156862745098,
                    "a": 1
                },
                "hsv": {
                    "h": 191.6129032258065,
                    "s": 0.1215686274509804,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-a2",
            "path": [
                "color",
                "A2"
            ]
        },
        "A3": {
            "value": "rgba(181, 240, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "A3",
                "hex": "b5f0ff",
                "rgb": {
                    "r": 181,
                    "g": 240,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 192.16216216216216,
                    "s": 1,
                    "l": 0.8549019607843138,
                    "a": 1
                },
                "hsv": {
                    "h": 192.16216216216216,
                    "s": 0.2901960784313725,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-a3",
            "path": [
                "color",
                "A3"
            ]
        },
        "A4": {
            "value": "rgba(133, 233, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "A4",
                "hex": "85e9ff",
                "rgb": {
                    "r": 133,
                    "g": 233,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 190.81967213114754,
                    "s": 1,
                    "l": 0.7607843137254902,
                    "a": 1
                },
                "hsv": {
                    "h": 190.81967213114754,
                    "s": 0.4784313725490196,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-a4",
            "path": [
                "color",
                "A4"
            ]
        },
        "A5": {
            "value": "rgba(77, 225, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "A5",
                "hex": "4de1ff",
                "rgb": {
                    "r": 77,
                    "g": 225,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 190.11235955056182,
                    "s": 1,
                    "l": 0.6509803921568628,
                    "a": 1
                },
                "hsv": {
                    "h": 190.11235955056182,
                    "s": 0.6980392156862745,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-a5",
            "path": [
                "color",
                "A5"
            ]
        },
        "A6": {
            "value": "rgba(0, 213, 255, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "A6",
                "hex": "00d5ff",
                "rgb": {
                    "r": 0,
                    "g": 213,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 189.88235294117646,
                    "s": 1,
                    "l": 0.5,
                    "a": 1
                },
                "hsv": {
                    "h": 189.88235294117646,
                    "s": 1,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-a6",
            "path": [
                "color",
                "A6"
            ]
        },
        "A7": {
            "value": "rgba(0, 193, 232, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "A7",
                "hex": "00c1e8",
                "rgb": {
                    "r": 0,
                    "g": 193,
                    "b": 232,
                    "a": 1
                },
                "hsl": {
                    "h": 190.08620689655174,
                    "s": 1,
                    "l": 0.4549019607843137,
                    "a": 1
                },
                "hsv": {
                    "h": 190.08620689655174,
                    "s": 1,
                    "v": 0.9098039215686274,
                    "a": 1
                }
            },
            "name": "color-a7",
            "path": [
                "color",
                "A7"
            ]
        },
        "A8": {
            "value": "rgba(1, 162, 202, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "A8",
                "hex": "01a2ca",
                "rgb": {
                    "r": 1,
                    "g": 162,
                    "b": 202,
                    "a": 1
                },
                "hsl": {
                    "h": 191.94029850746267,
                    "s": 0.9901477832512315,
                    "l": 0.3980392156862745,
                    "a": 1
                },
                "hsv": {
                    "h": 191.94029850746267,
                    "s": 0.995049504950495,
                    "v": 0.792156862745098,
                    "a": 1
                }
            },
            "name": "color-a8",
            "path": [
                "color",
                "A8"
            ]
        },
        "A9": {
            "value": "rgba(2, 120, 167, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "A9",
                "hex": "0278a7",
                "rgb": {
                    "r": 2,
                    "g": 120,
                    "b": 167,
                    "a": 1
                },
                "hsl": {
                    "h": 197.09090909090912,
                    "s": 0.9763313609467457,
                    "l": 0.33137254901960783,
                    "a": 1
                },
                "hsv": {
                    "h": 197.09090909090912,
                    "s": 0.9880239520958084,
                    "v": 0.6549019607843137,
                    "a": 1
                }
            },
            "name": "color-a9",
            "path": [
                "color",
                "A9"
            ]
        },
        "A10": {
            "value": "rgba(5, 73, 118, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "A10",
                "hex": "054976",
                "rgb": {
                    "r": 5,
                    "g": 73,
                    "b": 118,
                    "a": 1
                },
                "hsl": {
                    "h": 203.89380530973452,
                    "s": 0.91869918699187,
                    "l": 0.2411764705882353,
                    "a": 1
                },
                "hsv": {
                    "h": 203.89380530973452,
                    "s": 0.9576271186440678,
                    "v": 0.4627450980392157,
                    "a": 1
                }
            },
            "name": "color-a10",
            "path": [
                "color",
                "A10"
            ]
        },
        "B1": {
            "value": "rgba(240, 247, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "B1",
                "hex": "f0f7ff",
                "rgb": {
                    "r": 240,
                    "g": 247,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 212,
                    "s": 1,
                    "l": 0.9705882352941176,
                    "a": 1
                },
                "hsv": {
                    "h": 212,
                    "s": 0.05882352941176472,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-b1",
            "path": [
                "color",
                "B1"
            ]
        },
        "B2": {
            "value": "rgba(213, 234, 254, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "B2",
                "hex": "d5eafe",
                "rgb": {
                    "r": 213,
                    "g": 234,
                    "b": 254,
                    "a": 1
                },
                "hsl": {
                    "h": 209.26829268292687,
                    "s": 0.9534883720930234,
                    "l": 0.915686274509804,
                    "a": 1
                },
                "hsv": {
                    "h": 209.26829268292687,
                    "s": 0.16141732283464566,
                    "v": 0.996078431372549,
                    "a": 1
                }
            },
            "name": "color-b2",
            "path": [
                "color",
                "B2"
            ]
        },
        "B3": {
            "value": "rgba(128, 189, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "B3",
                "hex": "80bdff",
                "rgb": {
                    "r": 128,
                    "g": 189,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 211.1811023622047,
                    "s": 1,
                    "l": 0.7509803921568627,
                    "a": 1
                },
                "hsv": {
                    "h": 211.1811023622047,
                    "s": 0.4980392156862745,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-b3",
            "path": [
                "color",
                "B3"
            ]
        },
        "B4": {
            "value": "rgba(47, 133, 247, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "B4",
                "hex": "2f85f7",
                "rgb": {
                    "r": 47,
                    "g": 133,
                    "b": 247,
                    "a": 1
                },
                "hsl": {
                    "h": 214.2,
                    "s": 0.925925925925926,
                    "l": 0.5764705882352941,
                    "a": 1
                },
                "hsv": {
                    "h": 214.2,
                    "s": 0.8097165991902834,
                    "v": 0.9686274509803922,
                    "a": 1
                }
            },
            "name": "color-b4",
            "path": [
                "color",
                "B4"
            ]
        },
        "B5": {
            "value": "rgba(35, 118, 229, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "B5",
                "hex": "2376e5",
                "rgb": {
                    "r": 35,
                    "g": 118,
                    "b": 229,
                    "a": 1
                },
                "hsl": {
                    "h": 214.3298969072165,
                    "s": 0.7886178861788616,
                    "l": 0.5176470588235295,
                    "a": 1
                },
                "hsv": {
                    "h": 214.3298969072165,
                    "s": 0.8471615720524017,
                    "v": 0.8980392156862745,
                    "a": 1
                }
            },
            "name": "color-b5",
            "path": [
                "color",
                "B5"
            ]
        },
        "B6": {
            "value": "rgba(38, 94, 212, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "B6",
                "hex": "265ed4",
                "rgb": {
                    "r": 38,
                    "g": 94,
                    "b": 212,
                    "a": 1
                },
                "hsl": {
                    "h": 220.68965517241378,
                    "s": 0.696,
                    "l": 0.4901960784313726,
                    "a": 1
                },
                "hsv": {
                    "h": 220.68965517241378,
                    "s": 0.820754716981132,
                    "v": 0.8313725490196079,
                    "a": 1
                }
            },
            "name": "color-b6",
            "path": [
                "color",
                "B6"
            ]
        },
        "B7": {
            "value": "rgba(26, 76, 174, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "B7",
                "hex": "1a4cae",
                "rgb": {
                    "r": 26,
                    "g": 76,
                    "b": 174,
                    "a": 1
                },
                "hsl": {
                    "h": 219.7297297297297,
                    "s": 0.7400000000000001,
                    "l": 0.39215686274509803,
                    "a": 1
                },
                "hsv": {
                    "h": 219.7297297297297,
                    "s": 0.8505747126436782,
                    "v": 0.6823529411764706,
                    "a": 1
                }
            },
            "name": "color-b7",
            "path": [
                "color",
                "B7"
            ]
        },
        "B8": {
            "value": "rgba(27, 69, 150, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "B8",
                "hex": "1b4596",
                "rgb": {
                    "r": 27,
                    "g": 69,
                    "b": 150,
                    "a": 1
                },
                "hsl": {
                    "h": 219.5121951219512,
                    "s": 0.6949152542372882,
                    "l": 0.34705882352941175,
                    "a": 1
                },
                "hsv": {
                    "h": 219.5121951219512,
                    "s": 0.82,
                    "v": 0.5882352941176471,
                    "a": 1
                }
            },
            "name": "color-b8",
            "path": [
                "color",
                "B8"
            ]
        },
        "B9": {
            "value": "rgba(29, 61, 126, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "B9",
                "hex": "1d3d7e",
                "rgb": {
                    "r": 29,
                    "g": 61,
                    "b": 126,
                    "a": 1
                },
                "hsl": {
                    "h": 220.20618556701032,
                    "s": 0.6258064516129033,
                    "l": 0.303921568627451,
                    "a": 1
                },
                "hsv": {
                    "h": 220.20618556701032,
                    "s": 0.7698412698412699,
                    "v": 0.49411764705882355,
                    "a": 1
                }
            },
            "name": "color-b9",
            "path": [
                "color",
                "B9"
            ]
        },
        "B10": {
            "value": "rgba(34, 51, 103, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "B10",
                "hex": "223367",
                "rgb": {
                    "r": 34,
                    "g": 51,
                    "b": 103,
                    "a": 1
                },
                "hsl": {
                    "h": 225.2173913043478,
                    "s": 0.5036496350364964,
                    "l": 0.26862745098039215,
                    "a": 1
                },
                "hsv": {
                    "h": 225.2173913043478,
                    "s": 0.6699029126213593,
                    "v": 0.403921568627451,
                    "a": 1
                }
            },
            "name": "color-b10",
            "path": [
                "color",
                "B10"
            ]
        },
        "P1": {
            "value": "rgba(248, 247, 253, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "P1",
                "hex": "f8f7fd",
                "rgb": {
                    "r": 248,
                    "g": 247,
                    "b": 253,
                    "a": 1
                },
                "hsl": {
                    "h": 249.99999999999994,
                    "s": 0.6000000000000011,
                    "l": 0.9803921568627452,
                    "a": 1
                },
                "hsv": {
                    "h": 249.99999999999994,
                    "s": 0.023715415019762872,
                    "v": 0.9921568627450981,
                    "a": 1
                }
            },
            "name": "color-p1",
            "path": [
                "color",
                "P1"
            ]
        },
        "P2": {
            "value": "rgba(230, 227, 247, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "P2",
                "hex": "e6e3f7",
                "rgb": {
                    "r": 230,
                    "g": 227,
                    "b": 247,
                    "a": 1
                },
                "hsl": {
                    "h": 249.00000000000003,
                    "s": 0.5555555555555561,
                    "l": 0.9294117647058824,
                    "a": 1
                },
                "hsv": {
                    "h": 249.00000000000003,
                    "s": 0.0809716599190284,
                    "v": 0.9686274509803922,
                    "a": 1
                }
            },
            "name": "color-p2",
            "path": [
                "color",
                "P2"
            ]
        },
        "P3": {
            "value": "rgba(207, 201, 241, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "P3",
                "hex": "cfc9f1",
                "rgb": {
                    "r": 207,
                    "g": 201,
                    "b": 241,
                    "a": 1
                },
                "hsl": {
                    "h": 249.00000000000003,
                    "s": 0.588235294117647,
                    "l": 0.8666666666666667,
                    "a": 1
                },
                "hsv": {
                    "h": 249.00000000000003,
                    "s": 0.16597510373443983,
                    "v": 0.9450980392156862,
                    "a": 1
                }
            },
            "name": "color-p3",
            "path": [
                "color",
                "P3"
            ]
        },
        "P4": {
            "value": "rgba(183, 175, 235, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "P4",
                "hex": "b7afeb",
                "rgb": {
                    "r": 183,
                    "g": 175,
                    "b": 235,
                    "a": 1
                },
                "hsl": {
                    "h": 248.00000000000003,
                    "s": 0.5999999999999996,
                    "l": 0.803921568627451,
                    "a": 1
                },
                "hsv": {
                    "h": 248.00000000000003,
                    "s": 0.25531914893617014,
                    "v": 0.9215686274509803,
                    "a": 1
                }
            },
            "name": "color-p4",
            "path": [
                "color",
                "P4"
            ]
        },
        "P5": {
            "value": "rgba(160, 148, 228, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "P5",
                "hex": "a094e4",
                "rgb": {
                    "r": 160,
                    "g": 148,
                    "b": 228,
                    "a": 1
                },
                "hsl": {
                    "h": 248.99999999999994,
                    "s": 0.5970149253731343,
                    "l": 0.7372549019607844,
                    "a": 1
                },
                "hsv": {
                    "h": 248.99999999999994,
                    "s": 0.3508771929824561,
                    "v": 0.8941176470588236,
                    "a": 1
                }
            },
            "name": "color-p5",
            "path": [
                "color",
                "P5"
            ]
        },
        "P6": {
            "value": "rgba(136, 122, 222, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "P6",
                "hex": "887ade",
                "rgb": {
                    "r": 136,
                    "g": 122,
                    "b": 222,
                    "a": 1
                },
                "hsl": {
                    "h": 248.39999999999998,
                    "s": 0.6024096385542169,
                    "l": 0.6745098039215687,
                    "a": 1
                },
                "hsv": {
                    "h": 248.39999999999998,
                    "s": 0.45045045045045046,
                    "v": 0.8705882352941177,
                    "a": 1
                }
            },
            "name": "color-p6",
            "path": [
                "color",
                "P6"
            ]
        },
        "P7": {
            "value": "rgba(114, 101, 193, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "P7",
                "hex": "7265c1",
                "rgb": {
                    "r": 114,
                    "g": 101,
                    "b": 193,
                    "a": 1
                },
                "hsl": {
                    "h": 248.4782608695652,
                    "s": 0.4259259259259259,
                    "l": 0.5764705882352941,
                    "a": 1
                },
                "hsv": {
                    "h": 248.4782608695652,
                    "s": 0.4766839378238342,
                    "v": 0.7568627450980392,
                    "a": 1
                }
            },
            "name": "color-p7",
            "path": [
                "color",
                "P7"
            ]
        },
        "P8": {
            "value": "rgba(92, 80, 164, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "P8",
                "hex": "5c50a4",
                "rgb": {
                    "r": 92,
                    "g": 80,
                    "b": 164,
                    "a": 1
                },
                "hsl": {
                    "h": 248.5714285714286,
                    "s": 0.34426229508196726,
                    "l": 0.47843137254901963,
                    "a": 1
                },
                "hsv": {
                    "h": 248.5714285714286,
                    "s": 0.5121951219512195,
                    "v": 0.6431372549019608,
                    "a": 1
                }
            },
            "name": "color-p8",
            "path": [
                "color",
                "P8"
            ]
        },
        "P9": {
            "value": "rgba(70, 59, 135, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "P9",
                "hex": "463b87",
                "rgb": {
                    "r": 70,
                    "g": 59,
                    "b": 135,
                    "a": 1
                },
                "hsl": {
                    "h": 248.68421052631578,
                    "s": 0.3917525773195876,
                    "l": 0.3803921568627451,
                    "a": 1
                },
                "hsv": {
                    "h": 248.68421052631578,
                    "s": 0.562962962962963,
                    "v": 0.5294117647058824,
                    "a": 1
                }
            },
            "name": "color-p9",
            "path": [
                "color",
                "P9"
            ]
        },
        "P10": {
            "value": "rgba(39, 31, 85, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "P10",
                "hex": "271f55",
                "rgb": {
                    "r": 39,
                    "g": 31,
                    "b": 85,
                    "a": 1
                },
                "hsl": {
                    "h": 248.88888888888889,
                    "s": 0.4655172413793103,
                    "l": 0.22745098039215686,
                    "a": 1
                },
                "hsv": {
                    "h": 248.88888888888889,
                    "s": 0.6352941176470588,
                    "v": 0.3333333333333333,
                    "a": 1
                }
            },
            "name": "color-p10",
            "path": [
                "color",
                "P10"
            ]
        },
        "M1": {
            "value": "rgba(253, 247, 252, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "M1",
                "hex": "fdf7fc",
                "rgb": {
                    "r": 253,
                    "g": 247,
                    "b": 252,
                    "a": 1
                },
                "hsl": {
                    "h": 310,
                    "s": 0.6000000000000011,
                    "l": 0.9803921568627452,
                    "a": 1
                },
                "hsv": {
                    "h": 310,
                    "s": 0.023715415019762872,
                    "v": 0.9921568627450981,
                    "a": 1
                }
            },
            "name": "color-m1",
            "path": [
                "color",
                "M1"
            ]
        },
        "M2": {
            "value": "rgba(246, 223, 243, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "M2",
                "hex": "f6dff3",
                "rgb": {
                    "r": 246,
                    "g": 223,
                    "b": 243,
                    "a": 1
                },
                "hsl": {
                    "h": 307.8260869565218,
                    "s": 0.5609756097560981,
                    "l": 0.919607843137255,
                    "a": 1
                },
                "hsv": {
                    "h": 307.8260869565218,
                    "s": 0.0934959349593496,
                    "v": 0.9647058823529412,
                    "a": 1
                }
            },
            "name": "color-m2",
            "path": [
                "color",
                "M2"
            ]
        },
        "M3": {
            "value": "rgba(239, 192, 232, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "M3",
                "hex": "efc0e8",
                "rgb": {
                    "r": 239,
                    "g": 192,
                    "b": 232,
                    "a": 1
                },
                "hsl": {
                    "h": 308.93617021276594,
                    "s": 0.5949367088607596,
                    "l": 0.8450980392156863,
                    "a": 1
                },
                "hsv": {
                    "h": 308.93617021276594,
                    "s": 0.19665271966527198,
                    "v": 0.9372549019607843,
                    "a": 1
                }
            },
            "name": "color-m3",
            "path": [
                "color",
                "M3"
            ]
        },
        "M4": {
            "value": "rgba(231, 162, 222, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "M4",
                "hex": "e7a2de",
                "rgb": {
                    "r": 231,
                    "g": 162,
                    "b": 222,
                    "a": 1
                },
                "hsl": {
                    "h": 307.8260869565217,
                    "s": 0.5897435897435896,
                    "l": 0.7705882352941176,
                    "a": 1
                },
                "hsv": {
                    "h": 307.8260869565217,
                    "s": 0.29870129870129875,
                    "v": 0.9058823529411765,
                    "a": 1
                }
            },
            "name": "color-m4",
            "path": [
                "color",
                "M4"
            ]
        },
        "M5": {
            "value": "rgba(224, 131, 211, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "M5",
                "hex": "e083d3",
                "rgb": {
                    "r": 224,
                    "g": 131,
                    "b": 211,
                    "a": 1
                },
                "hsl": {
                    "h": 308.38709677419354,
                    "s": 0.6,
                    "l": 0.696078431372549,
                    "a": 1
                },
                "hsv": {
                    "h": 308.38709677419354,
                    "s": 0.41517857142857145,
                    "v": 0.8784313725490196,
                    "a": 1
                }
            },
            "name": "color-m5",
            "path": [
                "color",
                "M5"
            ]
        },
        "M6": {
            "value": "rgba(216, 100, 201, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "M6",
                "hex": "d864c9",
                "rgb": {
                    "r": 216,
                    "g": 100,
                    "b": 201,
                    "a": 1
                },
                "hsl": {
                    "h": 307.7586206896552,
                    "s": 0.5979381443298969,
                    "l": 0.6196078431372549,
                    "a": 1
                },
                "hsv": {
                    "h": 307.7586206896552,
                    "s": 0.5370370370370371,
                    "v": 0.8470588235294118,
                    "a": 1
                }
            },
            "name": "color-m6",
            "path": [
                "color",
                "M6"
            ]
        },
        "M7": {
            "value": "rgba(190, 84, 176, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "M7",
                "hex": "be54b0",
                "rgb": {
                    "r": 190,
                    "g": 84,
                    "b": 176,
                    "a": 1
                },
                "hsl": {
                    "h": 307.92452830188677,
                    "s": 0.4491525423728814,
                    "l": 0.5372549019607843,
                    "a": 1
                },
                "hsv": {
                    "h": 307.92452830188677,
                    "s": 0.5578947368421053,
                    "v": 0.7450980392156863,
                    "a": 1
                }
            },
            "name": "color-m7",
            "path": [
                "color",
                "M7"
            ]
        },
        "M8": {
            "value": "rgba(164, 67, 151, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "M8",
                "hex": "a44397",
                "rgb": {
                    "r": 164,
                    "g": 67,
                    "b": 151,
                    "a": 1
                },
                "hsl": {
                    "h": 308.0412371134021,
                    "s": 0.4199134199134199,
                    "l": 0.4529411764705883,
                    "a": 1
                },
                "hsv": {
                    "h": 308.0412371134021,
                    "s": 0.5914634146341463,
                    "v": 0.6431372549019608,
                    "a": 1
                }
            },
            "name": "color-m8",
            "path": [
                "color",
                "M8"
            ]
        },
        "M9": {
            "value": "rgba(138, 51, 126, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "M9",
                "hex": "8a337e",
                "rgb": {
                    "r": 138,
                    "g": 51,
                    "b": 126,
                    "a": 1
                },
                "hsl": {
                    "h": 308.27586206896547,
                    "s": 0.46031746031746024,
                    "l": 0.37058823529411766,
                    "a": 1
                },
                "hsv": {
                    "h": 308.27586206896547,
                    "s": 0.6304347826086956,
                    "v": 0.5411764705882353,
                    "a": 1
                }
            },
            "name": "color-m9",
            "path": [
                "color",
                "M9"
            ]
        },
        "M10": {
            "value": "rgba(101, 41, 93, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "M10",
                "hex": "65295d",
                "rgb": {
                    "r": 101,
                    "g": 41,
                    "b": 93,
                    "a": 1
                },
                "hsl": {
                    "h": 308,
                    "s": 0.42253521126760557,
                    "l": 0.2784313725490196,
                    "a": 1
                },
                "hsv": {
                    "h": 308,
                    "s": 0.594059405940594,
                    "v": 0.396078431372549,
                    "a": 1
                }
            },
            "name": "color-m10",
            "path": [
                "color",
                "M10"
            ]
        },
        "N1": {
            "value": "rgba(255, 255, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "N1",
                "hex": "ffffff",
                "rgb": {
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 0,
                    "s": 0,
                    "l": 1,
                    "a": 1
                },
                "hsv": {
                    "h": 0,
                    "s": 0,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-n1",
            "path": [
                "color",
                "N1"
            ]
        },
        "N2": {
            "value": "rgba(248, 249, 250, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "N2",
                "hex": "f8f9fa",
                "rgb": {
                    "r": 248,
                    "g": 249,
                    "b": 250,
                    "a": 1
                },
                "hsl": {
                    "h": 210,
                    "s": 0.16666666666666627,
                    "l": 0.9764705882352941,
                    "a": 1
                },
                "hsv": {
                    "h": 210,
                    "s": 0.007999999999999972,
                    "v": 0.9803921568627451,
                    "a": 1
                }
            },
            "name": "color-n2",
            "path": [
                "color",
                "N2"
            ]
        },
        "N3": {
            "value": "rgba(240, 244, 247, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "N3",
                "hex": "f0f4f7",
                "rgb": {
                    "r": 240,
                    "g": 244,
                    "b": 247,
                    "a": 1
                },
                "hsl": {
                    "h": 205.7142857142856,
                    "s": 0.304347826086957,
                    "l": 0.9549019607843137,
                    "a": 1
                },
                "hsv": {
                    "h": 205.7142857142856,
                    "s": 0.028340080971659933,
                    "v": 0.9686274509803922,
                    "a": 1
                }
            },
            "name": "color-n3",
            "path": [
                "color",
                "N3"
            ]
        },
        "N4": {
            "value": "rgba(232, 236, 242, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "N4",
                "hex": "e8ecf2",
                "rgb": {
                    "r": 232,
                    "g": 236,
                    "b": 242,
                    "a": 1
                },
                "hsl": {
                    "h": 215.99999999999991,
                    "s": 0.27777777777777746,
                    "l": 0.9294117647058824,
                    "a": 1
                },
                "hsv": {
                    "h": 215.99999999999991,
                    "s": 0.04132231404958675,
                    "v": 0.9490196078431372,
                    "a": 1
                }
            },
            "name": "color-n4",
            "path": [
                "color",
                "N4"
            ]
        },
        "N5": {
            "value": "rgba(213, 218, 227, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "N5",
                "hex": "d5dae3",
                "rgb": {
                    "r": 213,
                    "g": 218,
                    "b": 227,
                    "a": 1
                },
                "hsl": {
                    "h": 218.57142857142864,
                    "s": 0.19999999999999968,
                    "l": 0.8627450980392157,
                    "a": 1
                },
                "hsv": {
                    "h": 218.57142857142864,
                    "s": 0.0616740088105726,
                    "v": 0.8901960784313725,
                    "a": 1
                }
            },
            "name": "color-n5",
            "path": [
                "color",
                "N5"
            ]
        },
        "N6": {
            "value": "rgba(174, 183, 196, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "N6",
                "hex": "aeb7c4",
                "rgb": {
                    "r": 174,
                    "g": 183,
                    "b": 196,
                    "a": 1
                },
                "hsl": {
                    "h": 215.45454545454547,
                    "s": 0.15714285714285717,
                    "l": 0.7254901960784315,
                    "a": 1
                },
                "hsv": {
                    "h": 215.45454545454547,
                    "s": 0.1122448979591837,
                    "v": 0.7686274509803922,
                    "a": 1
                }
            },
            "name": "color-n6",
            "path": [
                "color",
                "N6"
            ]
        },
        "N7": {
            "value": "rgba(140, 150, 163, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "N7",
                "hex": "8c96a3",
                "rgb": {
                    "r": 140,
                    "g": 150,
                    "b": 163,
                    "a": 1
                },
                "hsl": {
                    "h": 213.91304347826087,
                    "s": 0.111111111111111,
                    "l": 0.5941176470588235,
                    "a": 1
                },
                "hsv": {
                    "h": 213.91304347826087,
                    "s": 0.14110429447852746,
                    "v": 0.6392156862745098,
                    "a": 1
                }
            },
            "name": "color-n7",
            "path": [
                "color",
                "N7"
            ]
        },
        "N8": {
            "value": "rgba(97, 108, 122, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "N8",
                "hex": "616c7a",
                "rgb": {
                    "r": 97,
                    "g": 108,
                    "b": 122,
                    "a": 1
                },
                "hsl": {
                    "h": 213.60000000000002,
                    "s": 0.11415525114155255,
                    "l": 0.4294117647058824,
                    "a": 1
                },
                "hsv": {
                    "h": 213.60000000000002,
                    "s": 0.20491803278688533,
                    "v": 0.47843137254901963,
                    "a": 1
                }
            },
            "name": "color-n8",
            "path": [
                "color",
                "N8"
            ]
        },
        "N9": {
            "value": "rgba(71, 81, 92, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "N9",
                "hex": "47515c",
                "rgb": {
                    "r": 71,
                    "g": 81,
                    "b": 92,
                    "a": 1
                },
                "hsl": {
                    "h": 211.42857142857144,
                    "s": 0.12883435582822084,
                    "l": 0.3196078431372549,
                    "a": 1
                },
                "hsv": {
                    "h": 211.42857142857144,
                    "s": 0.22826086956521735,
                    "v": 0.3607843137254902,
                    "a": 1
                }
            },
            "name": "color-n9",
            "path": [
                "color",
                "N9"
            ]
        },
        "N10": {
            "value": "rgba(48, 57, 69, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "N10",
                "hex": "303945",
                "rgb": {
                    "r": 48,
                    "g": 57,
                    "b": 69,
                    "a": 1
                },
                "hsl": {
                    "h": 214.28571428571428,
                    "s": 0.17948717948717946,
                    "l": 0.22941176470588234,
                    "a": 1
                },
                "hsv": {
                    "h": 214.28571428571428,
                    "s": 0.3043478260869565,
                    "v": 0.27058823529411763,
                    "a": 1
                }
            },
            "name": "color-n10",
            "path": [
                "color",
                "N10"
            ]
        },
        "black": {
            "value": "rgba(0, 0, 0, 1)",
            "$type": "color",
            "attributes": {
                "useContrastText": true,
                "category": "color",
                "type": "black",
                "hex": "000000",
                "rgb": {
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 1
                },
                "hsl": {
                    "h": 0,
                    "s": 0,
                    "l": 0,
                    "a": 1
                },
                "hsv": {
                    "h": 0,
                    "s": 0,
                    "v": 0,
                    "a": 1
                }
            },
            "name": "color-black",
            "path": [
                "color",
                "black"
            ]
        },
        "white": {
            "value": "rgba(255, 255, 255, 1)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "white",
                "hex": "ffffff",
                "rgb": {
                    "r": 255,
                    "g": 255,
                    "b": 255,
                    "a": 1
                },
                "hsl": {
                    "h": 0,
                    "s": 0,
                    "l": 1,
                    "a": 1
                },
                "hsv": {
                    "h": 0,
                    "s": 0,
                    "v": 1,
                    "a": 1
                }
            },
            "name": "color-white",
            "path": [
                "color",
                "white"
            ]
        },
        "transparent": {
            "value": "rgba(0, 0, 0, 0)",
            "$type": "color",
            "attributes": {
                "category": "color",
                "type": "transparent",
                "hex": "000000",
                "rgb": {
                    "r": 0,
                    "g": 0,
                    "b": 0,
                    "a": 0
                },
                "hsl": {
                    "h": 0,
                    "s": 0,
                    "l": 0,
                    "a": 0
                },
                "hsv": {
                    "h": 0,
                    "s": 0,
                    "v": 0,
                    "a": 0
                }
            },
            "name": "color-transparent",
            "path": [
                "color",
                "transparent"
            ]
        }
    },
    "palette": {
        "primary": {
            "light": {
                "value": "rgba(128, 189, 255, 1)",
                "name": "palette-primary-light",
                "attributes": {
                    "category": "palette",
                    "type": "primary",
                    "item": "light"
                },
                "path": [
                    "palette",
                    "primary",
                    "light"
                ]
            },
            "main": {
                "value": "rgba(38, 94, 212, 1)",
                "name": "palette-primary-main",
                "attributes": {
                    "category": "palette",
                    "type": "primary",
                    "item": "main"
                },
                "path": [
                    "palette",
                    "primary",
                    "main"
                ]
            },
            "dark": {
                "value": "rgba(27, 69, 150, 1)",
                "name": "palette-primary-dark",
                "attributes": {
                    "category": "palette",
                    "type": "primary",
                    "item": "dark"
                },
                "path": [
                    "palette",
                    "primary",
                    "dark"
                ]
            },
            "contrastText": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-primary-contrast-text",
                "attributes": {
                    "category": "palette",
                    "type": "primary",
                    "item": "contrastText"
                },
                "path": [
                    "palette",
                    "primary",
                    "contrastText"
                ]
            }
        },
        "secondary": {
            "light": {
                "value": "rgba(183, 175, 235, 1)",
                "name": "palette-secondary-light",
                "attributes": {
                    "category": "palette",
                    "type": "secondary",
                    "item": "light"
                },
                "path": [
                    "palette",
                    "secondary",
                    "light"
                ]
            },
            "main": {
                "value": "rgba(136, 122, 222, 1)",
                "name": "palette-secondary-main",
                "attributes": {
                    "category": "palette",
                    "type": "secondary",
                    "item": "main"
                },
                "path": [
                    "palette",
                    "secondary",
                    "main"
                ]
            },
            "dark": {
                "value": "rgba(92, 80, 164, 1)",
                "name": "palette-secondary-dark",
                "attributes": {
                    "category": "palette",
                    "type": "secondary",
                    "item": "dark"
                },
                "path": [
                    "palette",
                    "secondary",
                    "dark"
                ]
            },
            "contrastText": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-secondary-contrast-text",
                "attributes": {
                    "category": "palette",
                    "type": "secondary",
                    "item": "contrastText"
                },
                "path": [
                    "palette",
                    "secondary",
                    "contrastText"
                ]
            }
        },
        "error": {
            "light": {
                "value": "rgba(255, 159, 158, 1)",
                "name": "palette-error-light",
                "attributes": {
                    "category": "palette",
                    "type": "error",
                    "item": "light"
                },
                "path": [
                    "palette",
                    "error",
                    "light"
                ]
            },
            "main": {
                "value": "rgba(214, 63, 63, 1)",
                "name": "palette-error-main",
                "attributes": {
                    "category": "palette",
                    "type": "error",
                    "item": "main"
                },
                "path": [
                    "palette",
                    "error",
                    "main"
                ]
            },
            "dark": {
                "value": "rgba(147, 34, 34, 1)",
                "name": "palette-error-dark",
                "attributes": {
                    "category": "palette",
                    "type": "error",
                    "item": "dark"
                },
                "path": [
                    "palette",
                    "error",
                    "dark"
                ]
            },
            "contrastText": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-error-contrast-text",
                "attributes": {
                    "category": "palette",
                    "type": "error",
                    "item": "contrastText"
                },
                "path": [
                    "palette",
                    "error",
                    "contrastText"
                ]
            }
        },
        "warning": {
            "light": {
                "value": "rgba(231, 162, 222, 1)",
                "name": "palette-warning-light",
                "attributes": {
                    "category": "palette",
                    "type": "warning",
                    "item": "light"
                },
                "path": [
                    "palette",
                    "warning",
                    "light"
                ]
            },
            "main": {
                "value": "rgba(164, 67, 151, 1)",
                "name": "palette-warning-main",
                "attributes": {
                    "category": "palette",
                    "type": "warning",
                    "item": "main"
                },
                "path": [
                    "palette",
                    "warning",
                    "main"
                ]
            },
            "dark": {
                "value": "rgba(101, 41, 93, 1)",
                "name": "palette-warning-dark",
                "attributes": {
                    "category": "palette",
                    "type": "warning",
                    "item": "dark"
                },
                "path": [
                    "palette",
                    "warning",
                    "dark"
                ]
            },
            "contrastText": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-warning-contrast-text",
                "attributes": {
                    "category": "palette",
                    "type": "warning",
                    "item": "contrastText"
                },
                "path": [
                    "palette",
                    "warning",
                    "contrastText"
                ]
            }
        },
        "info": {
            "light": {
                "value": "rgba(128, 189, 255, 1)",
                "name": "palette-info-light",
                "attributes": {
                    "category": "palette",
                    "type": "info",
                    "item": "light"
                },
                "path": [
                    "palette",
                    "info",
                    "light"
                ]
            },
            "main": {
                "value": "rgba(38, 94, 212, 1)",
                "name": "palette-info-main",
                "attributes": {
                    "category": "palette",
                    "type": "info",
                    "item": "main"
                },
                "path": [
                    "palette",
                    "info",
                    "main"
                ]
            },
            "dark": {
                "value": "rgba(27, 69, 150, 1)",
                "name": "palette-info-dark",
                "attributes": {
                    "category": "palette",
                    "type": "info",
                    "item": "dark"
                },
                "path": [
                    "palette",
                    "info",
                    "dark"
                ]
            },
            "contrastText": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-info-contrast-text",
                "attributes": {
                    "category": "palette",
                    "type": "info",
                    "item": "contrastText"
                },
                "path": [
                    "palette",
                    "info",
                    "contrastText"
                ]
            }
        },
        "success": {
            "light": {
                "value": "rgba(30, 194, 142, 1)",
                "name": "palette-success-light",
                "attributes": {
                    "category": "palette",
                    "type": "success",
                    "item": "light"
                },
                "path": [
                    "palette",
                    "success",
                    "light"
                ]
            },
            "main": {
                "value": "rgba(10, 143, 107, 1)",
                "name": "palette-success-main",
                "attributes": {
                    "category": "palette",
                    "type": "success",
                    "item": "main"
                },
                "path": [
                    "palette",
                    "success",
                    "main"
                ]
            },
            "dark": {
                "value": "rgba(0, 83, 64, 1)",
                "name": "palette-success-dark",
                "attributes": {
                    "category": "palette",
                    "type": "success",
                    "item": "dark"
                },
                "path": [
                    "palette",
                    "success",
                    "dark"
                ]
            },
            "contrastText": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-success-contrast-text",
                "attributes": {
                    "category": "palette",
                    "type": "success",
                    "item": "contrastText"
                },
                "path": [
                    "palette",
                    "success",
                    "contrastText"
                ]
            }
        },
        "text": {
            "primary": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "palette-text-primary",
                "attributes": {
                    "category": "palette",
                    "type": "text",
                    "item": "primary"
                },
                "path": [
                    "palette",
                    "text",
                    "primary"
                ]
            },
            "secondary": {
                "value": "rgba(34, 51, 103, 1)",
                "name": "palette-text-secondary",
                "attributes": {
                    "category": "palette",
                    "type": "text",
                    "item": "secondary"
                },
                "path": [
                    "palette",
                    "text",
                    "secondary"
                ]
            },
            "disabled": {
                "value": "rgba(128, 189, 255, 1)",
                "name": "palette-text-disabled",
                "attributes": {
                    "category": "palette",
                    "type": "text",
                    "item": "disabled"
                },
                "path": [
                    "palette",
                    "text",
                    "disabled"
                ]
            }
        },
        "divider": {
            "value": "rgba(174, 183, 196, 1)",
            "name": "palette-divider",
            "attributes": {
                "category": "palette",
                "type": "divider"
            },
            "path": [
                "palette",
                "divider"
            ]
        },
        "common": {
            "black": {
                "value": "rgba(0, 0, 0, 1)",
                "name": "palette-common-black",
                "attributes": {
                    "category": "palette",
                    "type": "common",
                    "item": "black"
                },
                "path": [
                    "palette",
                    "common",
                    "black"
                ]
            },
            "white": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-common-white",
                "attributes": {
                    "category": "palette",
                    "type": "common",
                    "item": "white"
                },
                "path": [
                    "palette",
                    "common",
                    "white"
                ]
            }
        },
        "background": {
            "paper": {
                "value": "rgba(248, 249, 250, 1)",
                "name": "palette-background-paper",
                "attributes": {
                    "category": "palette",
                    "type": "background",
                    "item": "paper"
                },
                "path": [
                    "palette",
                    "background",
                    "paper"
                ]
            },
            "default": {
                "value": "rgba(255, 255, 255, 1)",
                "name": "palette-background-default",
                "attributes": {
                    "category": "palette",
                    "type": "background",
                    "item": "default"
                },
                "path": [
                    "palette",
                    "background",
                    "default"
                ]
            },
            "dark": {
                "value": "rgba(34, 51, 103, 1)",
                "name": "palette-background-dark",
                "attributes": {
                    "category": "palette",
                    "type": "background",
                    "item": "dark"
                },
                "path": [
                    "palette",
                    "background",
                    "dark"
                ]
            }
        },
        "link": {
            "default": {
                "value": "rgba(38, 94, 212, 1)",
                "name": "palette-link-default",
                "attributes": {
                    "category": "palette",
                    "type": "link",
                    "item": "default"
                },
                "path": [
                    "palette",
                    "link",
                    "default"
                ]
            },
            "contrast": {
                "value": "rgba(128, 189, 255, 1)",
                "name": "palette-link-contrast",
                "attributes": {
                    "category": "palette",
                    "type": "link",
                    "item": "contrast"
                },
                "path": [
                    "palette",
                    "link",
                    "contrast"
                ]
            }
        },
        "charting": {
            "categorical": {
                "dark": {
                    "Red": {
                        "value": "rgba(255, 159, 158, 1)",
                        "name": "palette-charting-categorical-dark-red",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Red"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Red"
                        ]
                    },
                    "Orange": {
                        "value": "rgba(255, 212, 93, 1)",
                        "name": "palette-charting-categorical-dark-orange",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Orange"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Orange"
                        ]
                    },
                    "Aqua": {
                        "value": "rgba(181, 240, 255, 1)",
                        "name": "palette-charting-categorical-dark-aqua",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Aqua"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Aqua"
                        ]
                    },
                    "Teal": {
                        "value": "rgba(154, 231, 236, 1)",
                        "name": "palette-charting-categorical-dark-teal",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Teal"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Teal"
                        ]
                    },
                    "Blue": {
                        "value": "rgba(38, 94, 212, 1)",
                        "name": "palette-charting-categorical-dark-blue",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Blue"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Blue"
                        ]
                    },
                    "Magenta": {
                        "value": "rgba(231, 162, 222, 1)",
                        "name": "palette-charting-categorical-dark-magenta",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Magenta"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Magenta"
                        ]
                    },
                    "Purple": {
                        "value": "rgba(183, 175, 235, 1)",
                        "name": "palette-charting-categorical-dark-purple",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Purple"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Purple"
                        ]
                    },
                    "Green": {
                        "value": "rgba(112, 221, 186, 1)",
                        "name": "palette-charting-categorical-dark-green",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "dark",
                            "state": "Green"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "dark",
                            "Green"
                        ]
                    }
                },
                "light": {
                    "Red": {
                        "value": "rgba(147, 34, 34, 1)",
                        "name": "palette-charting-categorical-light-red",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Red"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Red"
                        ]
                    },
                    "Orange": {
                        "value": "rgba(221, 101, 2, 1)",
                        "name": "palette-charting-categorical-light-orange",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Orange"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Orange"
                        ]
                    },
                    "Aqua": {
                        "value": "rgba(5, 73, 118, 1)",
                        "name": "palette-charting-categorical-light-aqua",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Aqua"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Aqua"
                        ]
                    },
                    "Teal": {
                        "value": "rgba(7, 142, 158, 1)",
                        "name": "palette-charting-categorical-light-teal",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Teal"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Teal"
                        ]
                    },
                    "Blue": {
                        "value": "rgba(38, 94, 212, 1)",
                        "name": "palette-charting-categorical-light-blue",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Blue"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Blue"
                        ]
                    },
                    "Magenta": {
                        "value": "rgba(101, 41, 93, 1)",
                        "name": "palette-charting-categorical-light-magenta",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Magenta"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Magenta"
                        ]
                    },
                    "Purple": {
                        "value": "rgba(92, 80, 164, 1)",
                        "name": "palette-charting-categorical-light-purple",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Purple"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Purple"
                        ]
                    },
                    "Green": {
                        "value": "rgba(0, 83, 64, 1)",
                        "name": "palette-charting-categorical-light-green",
                        "attributes": {
                            "category": "palette",
                            "type": "charting",
                            "item": "categorical",
                            "subitem": "light",
                            "state": "Green"
                        },
                        "path": [
                            "palette",
                            "charting",
                            "categorical",
                            "light",
                            "Green"
                        ]
                    }
                }
            }
        }
    },
    "font": {
        "family": {
            "default": {
                "value": "Lato, Arial, sans-serif",
                "$type": "fontFamily",
                "name": "font-family-default",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "default"
                },
                "path": [
                    "font",
                    "family",
                    "default"
                ]
            },
            "monospace": {
                "value": "monospace",
                "$type": "fontFamily",
                "name": "font-family-monospace",
                "attributes": {
                    "category": "font",
                    "type": "family",
                    "item": "monospace"
                },
                "path": [
                    "font",
                    "family",
                    "monospace"
                ]
            }
        },
        "size": {
            "5xl": {
                "value": "2.875rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "5xl"
                },
                "$type": "dimension",
                "name": "font-size-5xl",
                "path": [
                    "font",
                    "size",
                    "5xl"
                ]
            },
            "4xl": {
                "value": "2.25rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "4xl"
                },
                "$type": "dimension",
                "name": "font-size-4xl",
                "path": [
                    "font",
                    "size",
                    "4xl"
                ]
            },
            "3xl": {
                "value": "1.875rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "3xl"
                },
                "$type": "dimension",
                "name": "font-size-3xl",
                "path": [
                    "font",
                    "size",
                    "3xl"
                ]
            },
            "2xl": {
                "value": "1.5rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "2xl"
                },
                "$type": "dimension",
                "name": "font-size-2xl",
                "path": [
                    "font",
                    "size",
                    "2xl"
                ]
            },
            "xl": {
                "value": "1.25rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "xl"
                },
                "$type": "dimension",
                "name": "font-size-xl",
                "path": [
                    "font",
                    "size",
                    "xl"
                ]
            },
            "lg": {
                "value": "1.125rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "lg"
                },
                "$type": "dimension",
                "name": "font-size-lg",
                "path": [
                    "font",
                    "size",
                    "lg"
                ]
            },
            "md": {
                "value": "1rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "md"
                },
                "$type": "dimension",
                "name": "font-size-md",
                "path": [
                    "font",
                    "size",
                    "md"
                ]
            },
            "sm": {
                "value": "0.875rem",
                "attributes": {
                    "category": "size",
                    "type": "size",
                    "item": "sm"
                },
                "$type": "dimension",
                "name": "font-size-sm",
                "path": [
                    "font",
                    "size",
                    "sm"
                ]
            }
        },
        "weight": {
            "light": {
                "value": 300,
                "$type": "fontWeight",
                "name": "font-weight-light",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "light"
                },
                "path": [
                    "font",
                    "weight",
                    "light"
                ]
            },
            "regular": {
                "value": 400,
                "$type": "fontWeight",
                "name": "font-weight-regular",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "regular"
                },
                "path": [
                    "font",
                    "weight",
                    "regular"
                ]
            },
            "bold": {
                "value": 700,
                "$type": "fontWeight",
                "name": "font-weight-bold",
                "attributes": {
                    "category": "font",
                    "type": "weight",
                    "item": "bold"
                },
                "path": [
                    "font",
                    "weight",
                    "bold"
                ]
            }
        }
    },
    "spacing": {
        "0": {
            "value": "0px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "0"
            },
            "name": "spacing-0",
            "path": [
                "spacing",
                "0"
            ]
        },
        "1": {
            "value": "8px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "1"
            },
            "name": "spacing-1",
            "path": [
                "spacing",
                "1"
            ]
        },
        "2": {
            "value": "16px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "2"
            },
            "name": "spacing-2",
            "path": [
                "spacing",
                "2"
            ]
        },
        "3": {
            "value": "24px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "3"
            },
            "name": "spacing-3",
            "path": [
                "spacing",
                "3"
            ]
        },
        "4": {
            "value": "32px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "4"
            },
            "name": "spacing-4",
            "path": [
                "spacing",
                "4"
            ]
        },
        "5": {
            "value": "40px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "5"
            },
            "name": "spacing-5",
            "path": [
                "spacing",
                "5"
            ]
        },
        "6": {
            "value": "48px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "6"
            },
            "name": "spacing-6",
            "path": [
                "spacing",
                "6"
            ]
        },
        "7": {
            "value": "56px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "7"
            },
            "name": "spacing-7",
            "path": [
                "spacing",
                "7"
            ]
        },
        "8": {
            "value": "64px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "8"
            },
            "name": "spacing-8",
            "path": [
                "spacing",
                "8"
            ]
        },
        "10": {
            "value": "80px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "10"
            },
            "name": "spacing-10",
            "path": [
                "spacing",
                "10"
            ]
        },
        "11": {
            "value": "88px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "11"
            },
            "name": "spacing-11",
            "path": [
                "spacing",
                "11"
            ]
        },
        "12": {
            "value": "96px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "12"
            },
            "name": "spacing-12",
            "path": [
                "spacing",
                "12"
            ]
        },
        "13": {
            "value": "104px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "13"
            },
            "name": "spacing-13",
            "path": [
                "spacing",
                "13"
            ]
        },
        "14": {
            "value": "112px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "14"
            },
            "name": "spacing-14",
            "path": [
                "spacing",
                "14"
            ]
        },
        "15": {
            "value": "120px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "15"
            },
            "name": "spacing-15",
            "path": [
                "spacing",
                "15"
            ]
        },
        "16": {
            "value": "128px",
            "$type": "dimension",
            "attributes": {
                "forcePx": true,
                "category": "spacing",
                "type": "16"
            },
            "name": "spacing-16",
            "path": [
                "spacing",
                "16"
            ]
        },
        "baseSpacingValue": {
            "value": 8,
            "name": "spacing-base-spacing-value",
            "attributes": {
                "category": "spacing",
                "type": "baseSpacingValue"
            },
            "path": [
                "spacing",
                "baseSpacingValue"
            ]
        }
    },
    "typography": {
        "h1": {
            "color": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "typography-h1-color",
                "attributes": {
                    "category": "typography",
                    "type": "h1",
                    "item": "color"
                },
                "path": [
                    "typography",
                    "h1",
                    "color"
                ]
            },
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-h1-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "h1",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "h1",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-h1-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "h1",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "h1",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "2.875rem",
                "name": "typography-h1-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "h1",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "h1",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.375,
                "name": "typography-h1-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "h1",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "h1",
                    "lineHeight"
                ]
            },
            "margin": {
                "value": "46px 0 13px",
                "name": "typography-h1-margin",
                "attributes": {
                    "category": "typography",
                    "type": "h1",
                    "item": "margin"
                },
                "path": [
                    "typography",
                    "h1",
                    "margin"
                ]
            }
        },
        "h2": {
            "color": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "typography-h2-color",
                "attributes": {
                    "category": "typography",
                    "type": "h2",
                    "item": "color"
                },
                "path": [
                    "typography",
                    "h2",
                    "color"
                ]
            },
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-h2-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "h2",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "h2",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-h2-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "h2",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "h2",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "2.25rem",
                "name": "typography-h2-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "h2",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "h2",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.375,
                "name": "typography-h2-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "h2",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "h2",
                    "lineHeight"
                ]
            },
            "margin": {
                "value": "42px 0 16px",
                "name": "typography-h2-margin",
                "attributes": {
                    "category": "typography",
                    "type": "h2",
                    "item": "margin"
                },
                "path": [
                    "typography",
                    "h2",
                    "margin"
                ]
            }
        },
        "h3": {
            "color": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "typography-h3-color",
                "attributes": {
                    "category": "typography",
                    "type": "h3",
                    "item": "color"
                },
                "path": [
                    "typography",
                    "h3",
                    "color"
                ]
            },
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-h3-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "h3",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "h3",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-h3-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "h3",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "h3",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "1.875rem",
                "name": "typography-h3-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "h3",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "h3",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.375,
                "name": "typography-h3-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "h3",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "h3",
                    "lineHeight"
                ]
            },
            "margin": {
                "value": "40px 0 17px",
                "name": "typography-h3-margin",
                "attributes": {
                    "category": "typography",
                    "type": "h3",
                    "item": "margin"
                },
                "path": [
                    "typography",
                    "h3",
                    "margin"
                ]
            }
        },
        "h4": {
            "color": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "typography-h4-color",
                "attributes": {
                    "category": "typography",
                    "type": "h4",
                    "item": "color"
                },
                "path": [
                    "typography",
                    "h4",
                    "color"
                ]
            },
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-h4-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "h4",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "h4",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-h4-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "h4",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "h4",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "1.875rem",
                "name": "typography-h4-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "h4",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "h4",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.375,
                "name": "typography-h4-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "h4",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "h4",
                    "lineHeight"
                ]
            },
            "letterSpacing": {
                "value": "0.03125em",
                "name": "typography-h4-letter-spacing",
                "attributes": {
                    "category": "typography",
                    "type": "h4",
                    "item": "letterSpacing"
                },
                "path": [
                    "typography",
                    "h4",
                    "letterSpacing"
                ]
            },
            "margin": {
                "value": "38px 0 20px",
                "name": "typography-h4-margin",
                "attributes": {
                    "category": "typography",
                    "type": "h4",
                    "item": "margin"
                },
                "path": [
                    "typography",
                    "h4",
                    "margin"
                ]
            }
        },
        "h5": {
            "color": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "typography-h5-color",
                "attributes": {
                    "category": "typography",
                    "type": "h5",
                    "item": "color"
                },
                "path": [
                    "typography",
                    "h5",
                    "color"
                ]
            },
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-h5-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "h5",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "h5",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-h5-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "h5",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "h5",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "1.5rem",
                "name": "typography-h5-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "h5",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "h5",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.375,
                "name": "typography-h5-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "h5",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "h5",
                    "lineHeight"
                ]
            },
            "margin": {
                "value": "36px 0 22px",
                "name": "typography-h5-margin",
                "attributes": {
                    "category": "typography",
                    "type": "h5",
                    "item": "margin"
                },
                "path": [
                    "typography",
                    "h5",
                    "margin"
                ]
            }
        },
        "h6": {
            "color": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "typography-h6-color",
                "attributes": {
                    "category": "typography",
                    "type": "h6",
                    "item": "color"
                },
                "path": [
                    "typography",
                    "h6",
                    "color"
                ]
            },
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-h6-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "h6",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "h6",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-h6-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "h6",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "h6",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "1.25rem",
                "name": "typography-h6-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "h6",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "h6",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.375,
                "name": "typography-h6-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "h6",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "h6",
                    "lineHeight"
                ]
            },
            "margin": {
                "value": "34px 0 24px",
                "name": "typography-h6-margin",
                "attributes": {
                    "category": "typography",
                    "type": "h6",
                    "item": "margin"
                },
                "path": [
                    "typography",
                    "h6",
                    "margin"
                ]
            }
        },
        "subtitle1": {
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-subtitle1-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle1",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "subtitle1",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 400,
                "name": "typography-subtitle1-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle1",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "subtitle1",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "0.875rem",
                "name": "typography-subtitle1-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle1",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "subtitle1",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.5,
                "name": "typography-subtitle1-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle1",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "subtitle1",
                    "lineHeight"
                ]
            }
        },
        "subtitle2": {
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-subtitle2-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle2",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "subtitle2",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-subtitle2-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle2",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "subtitle2",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "0.875rem",
                "name": "typography-subtitle2-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle2",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "subtitle2",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.5,
                "name": "typography-subtitle2-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "subtitle2",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "subtitle2",
                    "lineHeight"
                ]
            }
        },
        "body": {
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-body-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "body",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "body",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 400,
                "name": "typography-body-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "body",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "body",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "1rem",
                "name": "typography-body-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "body",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "body",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.45,
                "name": "typography-body-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "body",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "body",
                    "lineHeight"
                ]
            }
        },
        "bodySmall": {
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-body-small-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "bodySmall",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "bodySmall",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 400,
                "name": "typography-body-small-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "bodySmall",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "bodySmall",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "0.875rem",
                "name": "typography-body-small-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "bodySmall",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "bodySmall",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.45,
                "name": "typography-body-small-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "bodySmall",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "bodySmall",
                    "lineHeight"
                ]
            }
        },
        "button": {
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-button-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "button",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "button",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-button-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "button",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "button",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "1rem",
                "name": "typography-button-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "button",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "button",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.5,
                "name": "typography-button-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "button",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "button",
                    "lineHeight"
                ]
            },
            "textTransform": {
                "value": "none",
                "name": "typography-button-text-transform",
                "attributes": {
                    "category": "typography",
                    "type": "button",
                    "item": "textTransform"
                },
                "path": [
                    "typography",
                    "button",
                    "textTransform"
                ]
            }
        },
        "caption": {
            "color": {
                "value": "rgba(71, 81, 92, 1)",
                "name": "typography-caption-color",
                "attributes": {
                    "category": "typography",
                    "type": "caption",
                    "item": "color"
                },
                "path": [
                    "typography",
                    "caption",
                    "color"
                ]
            },
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-caption-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "caption",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "caption",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 400,
                "name": "typography-caption-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "caption",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "caption",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "0.875rem",
                "name": "typography-caption-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "caption",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "caption",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 1.4,
                "name": "typography-caption-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "caption",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "caption",
                    "lineHeight"
                ]
            }
        },
        "overline": {
            "fontFamily": {
                "value": "Lato, Arial, sans-serif",
                "name": "typography-overline-font-family",
                "attributes": {
                    "category": "typography",
                    "type": "overline",
                    "item": "fontFamily"
                },
                "path": [
                    "typography",
                    "overline",
                    "fontFamily"
                ]
            },
            "fontWeight": {
                "value": 700,
                "name": "typography-overline-font-weight",
                "attributes": {
                    "category": "typography",
                    "type": "overline",
                    "item": "fontWeight"
                },
                "path": [
                    "typography",
                    "overline",
                    "fontWeight"
                ]
            },
            "fontSize": {
                "value": "1.5rem",
                "name": "typography-overline-font-size",
                "attributes": {
                    "category": "typography",
                    "type": "overline",
                    "item": "fontSize"
                },
                "path": [
                    "typography",
                    "overline",
                    "fontSize"
                ]
            },
            "lineHeight": {
                "value": 2,
                "name": "typography-overline-line-height",
                "attributes": {
                    "category": "typography",
                    "type": "overline",
                    "item": "lineHeight"
                },
                "path": [
                    "typography",
                    "overline",
                    "lineHeight"
                ]
            },
            "textTransform": {
                "value": "none",
                "name": "typography-overline-text-transform",
                "attributes": {
                    "category": "typography",
                    "type": "overline",
                    "item": "textTransform"
                },
                "path": [
                    "typography",
                    "overline",
                    "textTransform"
                ]
            }
        }
    }
};
export default varnishTokens;
//# sourceMappingURL=varnish-tokens.js.map